<div class="quests-list" [ngClass]="{'public': isPublic}">
  <div class="quests-list__item" *ngFor="let item of items">
    <brt-quest-list-item [data]="item"></brt-quest-list-item>
  </div>
</div>
